import { useState } from "react";
import {
    Box,
    Typography,
    Collapse,
    useMediaQuery,
    useTheme
} from "@mui/material";

const ServicioCard = ({ item }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const [open, setOpen] = useState(false);

    if (isMobile) {
        return (
            <Box
                onClick={() => setOpen(!open)}
                sx={{
                    minHeight: 350,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    px: 4,
                    py: 6,
                    cursor: "pointer",
                    transition: ".3s",

                    "&:active": {
                        transform: "scale(.98)",
                    },
                }}
            >
                <Box
                    component="img"
                    src={item.imagen}
                    alt={item.titulo}
                    sx={{
                        width: 120,
                        mb: 3,
                    }}
                />

                <Typography
                    sx={{
                        color: "#5a7056",
                        fontSize: "2rem",
                        fontWeight: 400,
                        mb: 2,
                    }}
                >
                    {item.titulo}
                </Typography>

                <Typography
                    sx={{
                        color: "#5a7056",
                        fontSize: "1.1rem",
                        mb: 3,
                    }}
                >
                    {item.descripcion}
                </Typography>

                <Collapse in={open}>
                    <Typography
                        sx={{
                            color: "#347571",
                            lineHeight: 1.8,
                        }}
                    >
                        {item.detalle}
                    </Typography>
                </Collapse>

                <Typography
                    sx={{
                        mt: 3,
                        color: "#347571",
                        fontWeight: 600,
                    }}
                >
                    {open ? "Ver menos" : "Ver más"}
                </Typography>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                minHeight: 600,
                perspective: "1200px",
            }}
        >
            <Box
                sx={{
                    position: "relative",
                    width: "100%",
                    height: 600,
                    transformStyle: "preserve-3d",
                    transition: "transform .8s",

                    "&:hover": {
                        transform:
                            "translateY(-15px) rotateY(180deg)",
                    },
                }}
            >
                {/* Frente */}
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        backfaceVisibility: "hidden",

                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center",

                        px: 4,
                        py: 10,
                    }}
                >
                    <Box
                        component="img"
                        src={item.imagen}
                        alt={item.titulo}
                        sx={{
                            width: 170,
                            mb: 5,
                        }}
                    />

                    <Typography
                        sx={{
                            color: "#4e6b4d",
                            fontSize: "2.6rem",
                            fontWeight: 400,
                            mb: 3,
                        }}
                    >
                        {item.titulo}
                    </Typography>

                    <Typography
                        sx={{
                            color: "#4e6b4d",
                            fontSize: "1.4rem",
                            lineHeight: 1.6,
                        }}
                    >
                        {item.descripcion}
                    </Typography>
                </Box>

                {/* Reverso */}
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,

                        transform: "rotateY(180deg)",
                        backfaceVisibility: "hidden",

                        background:
                            "linear-gradient(135deg,#347571,#4e6b4d)",

                        color: "#fff",

                        borderRadius: 3,

                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",

                        p: 4,
                        textAlign: "center",

                        boxShadow:
                            "0 20px 40px rgba(0,0,0,.15)",
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: "2rem",
                            fontWeight: 600,
                            mb: 3,
                        }}
                    >
                        {item.titulo}
                    </Typography>

                    <Typography
                        sx={{
                            lineHeight: 1.8,
                            fontSize: "1.1rem",
                        }}
                    >
                        {item.detalle}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default ServicioCard;